import { useAccessTokenStore } from '../store/useAccessTokenStore';

/** Return the access token if available. */
export function getAccessToken() {
  const accessToken = useAccessTokenStore.getState().accessToken;

  if (!accessToken) {
    throw new Error('Access token is not available, it can only be used within Authenticated wrapper');
  }

  return accessToken;
}
